export const SEND_VALIDATION_EMAIL_FIELD_MAX_LENGTH = {
  emailAmount: 25,
  customerName: 100,
};
